define(function () {
    return function EmptyViewModel() {
        // this is an empty view model, don't add stuff here
    };
});